__webpack_require__.b = document.baseURI || self.location.href;

      // object to store loaded and loading chunks
      // undefined = chunk not loaded, null = chunk preloaded/prefetched
      // [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
      var installedChunks = {48410: 0,95182: 0,};
      
        __webpack_require__.f.j = function (chunkId, promises) {
          // JSONP chunk loading for javascript
var installedChunkData = __webpack_require__.o(installedChunks, chunkId)
	? installedChunks[chunkId]
	: undefined;
if (installedChunkData !== 0) {
	// 0 means "already installed".

	// a Promise means "currently loading".
	if (installedChunkData) {
		promises.push(installedChunkData[2]);
	} else {
		if (/^(4(4(294|542|811)|2(616|623|768|790)|6(168|177|430)|8(244|410|723)|7(129|3|880)|1833|3330|5125|9072|9851)|2(0(405|559|735|76)|490(|2)|2(290|492|734|775)|1(142|396|761)|7(23|439|46|667)|3(5(16|3|64)|360)|9(9(|15|71)|07|669|726)|662|6900|8833)|5(0(20|425|446|541)|4(122|507|685|699)|6(104|680|770|806)|1([02]14|02|20|453|528)|8(222|793|839|888)|7(059|196|34)|241|305|3433|5598|5828|9783|996)|6(0(181|291|929)|5(062|403|659|855)|8(129|233|284|837)|7(050|22|354|395|621)|(420|911|92)9|1181|1478|2402|3186|3857|6493|6530)|1(0(066|69|778)|4(9(32|53|76)|077|850)|2(760|869|885|933)|5(019|677|72)|6(095|651|686)|1(13|143|252)|8(062|263|740|812|835)|3(058|077|11|418|531|856)|9(311|367|530|940)|7478|7516)|8(2(658|719|935)|52(1|63)|1([03]99|597)|8(05|158|179|430|463|546)|7(260|28|36|681|969)|3(628|682|951|985)|9(009|068|320)|0750|0816|6573)|7(0(063|874|99)|4([03]51|978)|6(595|741|951)|1(130|532|547|899)|9(036|447|535|553|643|730)|3(036|112|195|379|698)|2074|5570|8684|8738)|3(0(22|460|564)|58(|8)|6(072|250|567)|1(032|685|869)|7(01|486|71|788|979)|(24|3)06|2655|4823|8939)|9(0(51|648|819)|7(297|403|455|874)|31(44|50)|9((5|59|77)4|70|823)|1304|2632|402|4490|5015|5429|6524|6841|8048|8547))$/.test(chunkId)) {
			// setup Promise in chunk cache
			var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
			promises.push((installedChunkData[2] = promise));

			// start chunk loading
			var url = __webpack_require__.p + __webpack_require__.u(chunkId);
			// create error before stack unwound to get useful stacktrace later
			var error = new Error();
			var loadingEnded = function (event) {
				if (__webpack_require__.o(installedChunks, chunkId)) {
					installedChunkData = installedChunks[chunkId];
					if (installedChunkData !== 0) installedChunks[chunkId] = undefined;
					if (installedChunkData) {
						var errorType =
							event && (event.type === 'load' ? 'missing' : event.type);
						var realSrc = event && event.target && event.target.src;
						error.message =
							'Loading chunk ' +
							chunkId +
							' failed.\n(' +
							errorType +
							': ' +
							realSrc +
							')';
						error.name = 'ChunkLoadError';
						error.type = errorType;
						error.request = realSrc;
						installedChunkData[1](error);
					}
				}
			};
			__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
		} else installedChunks[chunkId] = 0; 
	}
}

        }
        __webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
// install a JSONP callback for chunk loading
var __rspack_jsonp = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if (chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for (moduleId in moreModules) {
			if (__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if (runtime) var result = runtime(__webpack_require__);
	}
	if (parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for (; i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if (
			__webpack_require__.o(installedChunks, chunkId) &&
			installedChunks[chunkId]
		) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	
	return __webpack_require__.O(result);
	
};

var chunkLoadingGlobal = self["rspackChunkbokio"] = self["rspackChunkbokio"] || [];
chunkLoadingGlobal.forEach(__rspack_jsonp.bind(null, 0));
chunkLoadingGlobal.push = __rspack_jsonp.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
